// extracted by mini-css-extract-plugin
export default {"metrics_pm":"MemorandumValues_metrics_pm__dYW44","column_metrics":"MemorandumValues_column_metrics__ItIyB"};